export const APPLICATIONS = {
  STUDIOBFF: 'Studio%20BFF',
  BIITENSHELL: 'biitenshell ui',
};

export const INITIAL_SELECTED_VERSION_VALUE = {
  id: '',
  elbAddress: '',
  buildNumber: '',
};

export const INITIAL_ADD_DELETE_VERSION = {
  id: '',
  elbAddress: '',
  buildNumber: '',
  pattern: '',
  name: '',
};

export const INITIAL_DELETE_ALL_VERSION = [{
  id: '',
  elbAddress: '',
  buildNumber: '',
  pattern: '',
  name: '',
}];

export const INITIAL_UPGRADE_VERSION = {
  id: '',
  elbAddress: '',
  buildNumber: '',
  pattern: '',
  name: '',
};




